import { apiSlice } from "../../api/ApiService";
import { getHeadersFromRedux } from "../../utility/functions/common-functions";

const saveCelebrationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    saveCelebration: builder.mutation({
      query: ({
        body,
        patientProfileId,
        preferredLanguage,
        patientCaseId,
        userName,
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        headers["LoggedInUser"] = userName;
        return {
          url: `/api/v1/Patient/${patientProfileId}/${patientCaseId}/visual-celebration`,
          method: "PUT",
          data: body,
          headers,
        };
      },
      invalidatesTags: (result, error) => [{ type: "VisualCelebration" }],
    }),
  }),
  overrideExisting: false,
});

export const { useSaveCelebrationMutation } = saveCelebrationApi;
export default saveCelebrationApi;
